export const FETCH_DRIVERS = 'FETCH_DRIVERS'
export const FETCH_DRIVER = 'FETCH_DRIVER'
export const FETCH_DRIVER_AVATAR = 'FETCH_DRIVER_AVATAR'
export const FETCH_DRIVER_DOCUMENT = 'FETCH_DRIVER_DOCUMENT'
export const FETCH_DRIVER_INFORMATION = 'FETCH_DRIVER_INFORMATION'
export const FETCH_DRIVERS_NEXT_PAGE = 'FETCH_DRIVERS_NEXT_PAGE'
export const VALIDATE_DRIVER_CELLPHONE = 'VALIDATE_DRIVER_CELLPHONE'
